import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

extend("monetario", {
  validate: (value) => {
    let regex = /^(([1-9]\d{0,2}(,\d{3})*|[1-9]\d*|0|)(\.\d{1,2})?)$/;
    return regex.test(value);
  },
  message: "Este campo deve ter um valor monetário positivo",
});

extend("naoZero", {
  validate: (value) => {
    if (value == 0) {
      return false;
    }
    return true;
  },
  message: "Este campo deve ter um valor monetário positivo",
});

extend("data", {
  validate: (value) => {
    let regex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/;
    return regex.test(value);
  },
  message: "Este campo deve representar uma data válida no formato dd/mm/aaaa",
});
